import React from 'react';
import { Link } from 'react-router-dom'

import { Row, Col, Layout, Carousel, Radio, Icon} from 'antd'

import Footer from '../../components/Footer/Footer'
import classes from './PatientInformationSheet.css'

import PatientInformationSheetPage1 from "../../assets/documents/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-01.jpg";
import PatientInformationSheetPage2 from "../../assets/documents/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-02.jpg";
import PatientInformationSheetPage3 from "../../assets/documents/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-03.jpg";
import PatientInformationSheetPage4 from "../../assets/documents/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-04.jpg";
import PatientInformationSheetPage5 from "../../assets/documents/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-05.jpg";
import PatientInformationSheetPage6 from "../../assets/documents/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-06.jpg";
import PatientInformationSheetPage7 from "../../assets/documents/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-07.jpg";
import PatientInformationSheetPage8 from "../../assets/documents/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-08.jpg";
import PatientInformationSheetPage9 from "../../assets/documents/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-09.jpg";
import PatientInformationSheetPage10 from "../../assets/documents/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-10.jpg";
import PatientInformationSheetPage11 from "../../assets/documents/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-11.jpg";
import PatientInformationSheetPage12 from "../../assets/documents/2020-06-25-17-29-33-Ontario_Visual_Patient_Information_Sheet-12.jpg";

const { Content } = Layout;


export default class Home extends React.Component {

    constructor(props) {
      super(props);
      this.next = this.next.bind(this);
      this.previous = this.previous.bind(this);
      this.carousel = React.createRef();
    }

    next() {
      this.carousel.next();
    }

    previous() {
      this.carousel.prev();
    }


    render() {

        const props = {
          dots: true,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1
        };

        return (
            <div style={{ backgroundColor: '#FAFAFA' }}>
                <Layout className={classes.parentContainer}>
                    <Content className={classes.content}>
                        <Row>
                            <Col xs={{ span: 24 }} sm={{ span: 20, offset: 2 }} md={{ span: 16, offset: 4 }} style={{ paddingTop: '4rem' }}>
                                <h1 ><span style={{ color: '#286DA8' }}>AcT</span></h1>

                                <Row type='flex' justify='center'>
                                    <Col xs={24} sm={18} md={18} lg={20} xl={22} className='frosted-card'>
                                      <h2>AcT - Patient Information Sheet - Visual</h2>



                                        <Carousel ref={node => (this.carousel = node)} {...props}>
                                          <div>
                                            <h3><img alt="Patient Information Sheet Page 1" src={PatientInformationSheetPage1} style={{ objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' }} /></h3>
                                          </div>
                                          <div>
                                            <h3><img alt="Patient Information Sheet Page 2" src={PatientInformationSheetPage2} style={{ objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' }} /></h3>
                                            <p>You have just had a test. We examined you and took pictures of your brain. This showed you are having a stroke.</p>
                                          </div>
                                          <div>
                                            <h3><img alt="Patient Information Sheet Page 3" src={PatientInformationSheetPage3} style={{ objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' }} /></h3>
                                            <p>Common stroke signs are facial droop, weakness of one side of your body, or difficulty speaking or understanding.</p>
                                          </div>
                                          <div>
                                            <h3><img alt="Patient Information Sheet Page 4" src={PatientInformationSheetPage4} style={{ objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' }} /></h3>
                                            <p>Your stroke is caused by a blockage of an artery in the brain. In standard practice, we can treat some people with a medicine to break up the blockage (clot-busting medicine). This treatment has to be administered fast because injury to the brain happens quickly.</p>
                                          </div>
                                          <div>
                                            <h3><img alt="Patient Information Sheet Page 5" src={PatientInformationSheetPage5} style={{ objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' }} /></h3>
                                            <p>Someone saw your symptoms and you have been brought to the hospital to see if we can help your stroke.</p>
                                          </div>
                                          <div>
                                            <h3><img alt="Patient Information Sheet Page 6" src={PatientInformationSheetPage6} style={{ objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' }} /></h3>
                                            <p>You are a good candidate for a study about how best to treat your stroke. Let me explain.</p>
                                          </div>
                                          <div>
                                            <h3><img alt="Patient Information Sheet Page 7" src={PatientInformationSheetPage7} style={{ objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' }} /></h3>
                                            <p>In the study (called the “AcT” Study) we are comparing two clot-busting medicines: either alteplase (tPA) or tenecteplase (TNK). Both of these clot-busting drugs are approved treatments (alteplase for acute stroke and tenecteplase for acute heart attacks).  They are supposed to open the blocked artery in your brain. With this study we are trying to figure out if tenecteplase is as good as alteplase in treating patients with a stroke like yours.</p>
                                          </div>
                                          <div>
                                            <h3><img alt="Patient Information Sheet Page 8" src={PatientInformationSheetPage8} style={{ objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' }} /></h3>
                                            <p>Everyone in this study will get one of the two clot-busting medicines.  The rest of your care will be same as for every other stroke patient. We will provide more details to you and your family in the following hours and days.</p>
                                          </div>
                                          <div>
                                            <h3><img alt="Patient Information Sheet Page 8" src={PatientInformationSheetPage9} style={{ objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' }} /></h3>
                                          </div>
                                          <div>
                                            <h3><img alt="Patient Information Sheet Page 8" src={PatientInformationSheetPage10} style={{ objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' }} /></h3>
                                          </div>
                                          <div>
                                            <h3><img alt="Patient Information Sheet Page 8" src={PatientInformationSheetPage11} style={{ objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' }} /></h3>
                                          </div>
                                          <div>
                                            <h3><img alt="Patient Information Sheet Page 8" src={PatientInformationSheetPage12} style={{ objectFit: 'contain', width: '100%', minWidth: 200, height: 'auto' }} /></h3>
                                          </div>
                                        </Carousel>
                                        <h4>
                                        <a onClick={this.previous}><Icon type="left-circle" style={{ color: '#FAFAFA' }} /> Previous</a>
                                        &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
                                        <a onClick={this.next}>Next <Icon type="right-circle" style={{ color: '#FAFAFA' }}  /></a>
                                        </h4>
                                      <ul>
                                        <li><Link to='/' style={{ color: '#FAFAFA' }} className='menu-item'> Home </Link></li>
                                        <li><Link to='/randomize' style={{ color: '#FAFAFA' }} className='menu-item'> Randomize </Link></li>
                                      </ul>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Content>
                    <Footer />
                </Layout>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/PatientInformationSheet/PatientInformationSheetVisual.js